import React, { useState, useEffect, useRef } from 'react';
import bee from '../assets/img/bee.gif';

function BeeFlyArround2() {
  // Bee’s position in state to trigger re-renders
  const [position, setPosition] = useState({ x: 100, y: 100 });

  // Bee’s facing direction for flipping the sprite (1 = right, -1 = left)
  const [direction, setDirection] = useState(1);

  // A ref for the bee’s heading (in radians).
  // We'll alter this slightly each frame for random “zigzag” flight.
  const headingRef = useRef(0);

  // requestAnimationFrame ID ref
  const animationFrameRef = useRef(null);

  // Adjust these constants to tweak “bee-like” flight
  const SPEED = 3;           // how fast the bee moves
  const TURN_RANGE = 0.1;    // max random turn in radians each frame (smaller = smoother)
  const BEE_WIDTH = 100;     // your bee GIF width
  const BEE_HEIGHT = 100;    // your bee GIF height

  useEffect(() => {
    const animate = () => {
      setPosition((prevPos) => {
        const { innerWidth, innerHeight } = window;

        // Slightly randomize heading for a “drunk” or “zigzag” effect
        // e.g. ±0.1 radians each frame
        headingRef.current += (Math.random() - 0.5) * TURN_RANGE;

        // Convert heading to velocity
        let dx = SPEED * Math.cos(headingRef.current);
        let dy = SPEED * Math.sin(headingRef.current);

        // Proposed new position
        let newX = prevPos.x + dx;
        let newY = prevPos.y + dy;

        // Bounce check horizontally
        if (newX < 0) {
          newX = 0;
          // Reverse heading horizontally
          headingRef.current = Math.PI - headingRef.current;
        } else if (newX + BEE_WIDTH > innerWidth) {
          newX = innerWidth - BEE_WIDTH;
          headingRef.current = Math.PI - headingRef.current;
        }

        // Bounce check vertically
        if (newY < 0) {
          newY = 0;
          // Reverse heading vertically
          headingRef.current = -headingRef.current;
        } else if (newY + BEE_HEIGHT > innerHeight) {
          newY = innerHeight - BEE_HEIGHT;
          headingRef.current = -headingRef.current;
        }

        // Determine which way to face: if dx is negative, flip left
        if (dx < 0) {
          setDirection(-1);
        } else {
          setDirection(1);
        }

        return { x: newX, y: newY };
      });

      // Request the next frame
      animationFrameRef.current = requestAnimationFrame(animate);
    };

    // Start the animation
    animationFrameRef.current = requestAnimationFrame(animate);

    // Cleanup on unmount
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  const beeStyle = {
    position: 'fixed',
    left: position.x,
    top: position.y,
    width: `${BEE_WIDTH}px`,
    height: `${BEE_HEIGHT}px`,
    pointerEvents: 'none', // don't block clicks
    zIndex: 9999,          // keep on top
    transform: `scaleX(${direction})`, // flip horizontally if facing left
  };

  return (
    <div style={beeStyle}>
      <img
        src={bee}
        alt="Bee"
        style={{ width: '50%', height: '50%' }}
      />
    </div>
  );
}

export default BeeFlyArround2;
